import { gql } from "lib/apolloClient";
import { staffUnitPlanFragment } from "./Fragments";

export const getStaffListQuery = gql`
  query getStaffList(
    $organizationId: ID!
    $searchText: String
    $grades: [ID!]
    $courses: [ID!]
    $archivalState: ARCHIVAL_STATE_ENUM
    $curriculumProgramIds: [ID!]
    $userArchivedFilters: UserArchivedFilters
    $academicYearIds: [ID!]
    $skipTitle: Boolean = false
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      ... on Organization {
        id
        staff(
          filters: {
            searchText: $searchText
            grades: $grades
            courses: $courses
            archivalState: $archivalState
            curriculumProgramIds: $curriculumProgramIds
            academicYearIds: $academicYearIds
          }
        ) {
          totalCount
          edges {
            node {
              isArchivedV2(filters: $userArchivedFilters)
              ...staffCoursesItem
            }
          }
        }
      }
    }
  }
  ${staffUnitPlanFragment.staffCourses}
`;

export const getCoursesFeedQuery = gql`
  query getCoursesFeed(
    $organizationId: ID!
    $filters: LearningCourseFilters
    $after: String
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        learningCourses(first: 20, after: $after, filters: $filters) {
          edges {
            node {
              id
              title
              isArchived
              academicYears {
                id
                startDate
                endDate
              }
              curriculumProgram {
                id
                acronym
                type
                nodeInterfaceType
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
`;

export const getClassesFeedQuery = gql`
  query getClassesFeed(
    $organizationId: ID!
    $filters: CourseFilterInput
    $after: String
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        classes: courses(filters: $filters, first: 20, after: $after) {
          edges {
            node {
              id
              title
              isArchived
              academicYears {
                id
                label
                startDate
                endDate
              }
              curriculumProgram {
                id
                acronym
                type
                nodeInterfaceType
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
`;

export const getOrganizationSubjectsQuery = gql`
  query getOrganizationSubjects($id: ID!, $filters: SubjectFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        subjects(filters: $filters) {
          id
          name
          isArchived
          grades {
            id
            name
          }
          curriculumProgram {
            id
            acronym
            type
            nodeInterfaceType
          }
        }
      }
    }
  }
`;
